module.exports = __webpack_public_path__ + "static/media/19_bitmore.b7ba2a50.svg";